import axios from "axios";
// config
import { HOST_API_KEY } from "../config-global";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API_KEY,
  headers: {
    "X-CSRF-TOKEN": document.head
      .querySelector('meta[name="csrf_token"]')
      ?.getAttribute("content"),
    "ngrok-skip-browser-warning": "skip-browser-warning",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export default axiosInstance;
